<template>
    <section class="gh-section gh-suicide-prevention__faqs" id="faqs">
        <div class="container">
            <h4 class="section-heading gh-heading gh-blue">Frequently Asked Questions</h4>
            <div v-for="faq in faqs" :key="faq.id" style="border-bottom: 1px solid #B3B3B3;">
                <div>
                    <p @click="toggleFaq(faq.id)" class="text" style="padding: 10px 0 10px 3px; cursor: pointer;" >
                        <span class="gh-faq-text" :style="'color: ' + ((faq.id === showId)?'#F76C6C':'#0C0C0E')">{{faq.question}}</span>
                        <!--<i v-if="arrow" class="gh-arrow" :style="'color: ' + ((faq.id === showId)?'#32495e':'#faa433')" :class="'fa fa-arrow-'+ ((faq.id === showId)?'up':'down')"></i>-->
                        <img v-if="arrow && faq.id !== showId" class="gh-arrow" src="/images/suicidePreventionSummit/Down-Grey-Arrow.svg" alt="">
                        <img v-if="arrow && faq.id === showId" class="gh-arrow" src="/images/suicidePreventionSummit/Up-Pink-Arrow.svg" alt="">

                        <!-- <span v-if="arrow && faq.id === showId" class="gh-arrow-text gh-cyan">LESS</span> -->
                    </p>
                </div>
                <div v-if="faq.id === showId">
                    <div class="text">
                        <div class="faq-answer" v-html="faq.answer"></div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        data () {
            return {
                showId: 0,
                arrow: false
            }
        },

        computed: {
            faqs() {
                return this.$store.state.event.eventFaqs
            }
        },

        created() {
            if(window.innerWidth >= 768) {
                this.arrow = true
            }
            window.addEventListener('resize', this.onResize)
        },
        methods: {
            toggleFaq (id) {
                if(this.showId === id) {
                    this.showId = 0
                } else {
                    this.showId = id
                }

            },
            onResize() {
                if (window.innerWidth >= 768) {
                    this.arrow = true
                } else {
                    this.arrow = false
                }
            },
        }
    }
</script>
<style lang="scss" scoped>
    #faqs {
        background-color: #F5F7FA;
    }

    .text {
        font-size: 1.1rem;
    }

    .gh-heading {
        font-size: 2.5rem;
        font-weight: 600;
        text-align: center;
        margin-bottom: 40px;
        @media (max-width: 767px) {
            font-size: 1.7rem;
            margin-bottom: 10px;
        }
    }
    .gh-arrow-text {
        float: right;
        margin-right: 10px;
        margin-top: 5px;
        font-size: 16px;
    }
    .gh-arrow {
        margin-top: .2rem;
        width: 20px;
        float: right;
    }
    .gh-faq-text{
        font-size: 1.2rem;
        font-weight: 500;
        @media (min-width: 1024px) {
            font-size: 1.3rem;
        }
    }
</style>

<style lang="scss">
    .gh-suicide-prevention__faqs {
        font-family: proxima-nova,sans-serif;
        background-color: #F5F7FA;
        .faq-answer {
            padding: 5px 0 20px 3px;
            p {
                font-size: 1.1rem;
                font-weight: 500;
                + p {
                    margin-top: 1rem;
                }
            }

            @media (min-width: 1024px) {
                padding: 20px 0 20px 3px;
            }
        }
    }
</style>
